class CollectionZoomCarousel extends HTMLElement {
  constructor() {
    super();

    this.swiper = false;
    this.pointerStart = null;
  }

  connectedCallback() {
    if (!this.querySelector('.swiper')) return;

    // Wait for Swiper to be loaded
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.initSwiper(), 100);
      return;
    }

    this.initSwiper();
    this.positionFloatingElements();
    this.bindLinkGuards();
  }

  disableNativeImageDrag() {
    this.querySelectorAll('img').forEach((img) => {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', (event) => event.preventDefault());
    });
  }

  bindLinkGuards() {
    this.disableNativeImageDrag();

    this.querySelectorAll('.collection-zoom-carousel__image-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!this.swiper) return;
        // After a swipe/drag, Swiper marks allowClick false — block navigation.
        if (this.swiper.allowClick === false) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.initSwiper(), 100);
      return;
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    const slides = this.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    const middleIndex = Math.floor(slides.length / 2);
    const swiperEl = this.querySelector('.swiper');
    const nextButton = swiperEl.querySelector('[data-carousel-next]');
    const prevButton = swiperEl.querySelector('[data-carousel-prev]');

    if (nextButton) {
      nextButton.style.display = 'flex';
      nextButton.style.opacity = '1';
      nextButton.style.visibility = 'visible';
    }
    if (prevButton) {
      prevButton.style.display = 'flex';
      prevButton.style.opacity = '1';
      prevButton.style.visibility = 'visible';
    }

    const getInitialSlide = () =>
      slides.length % 2 === 0 ? middleIndex - 1 : middleIndex;

    const autoplayEnabled = this.dataset.autoplay !== 'false' && this.dataset.autoplay !== '';
    const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 3000;

    const swiperOptions = {
      loop: true,
      // Prevent product links opening after a swipe/drag
      preventClicks: true,
      preventClicksPropagation: true,
      touchStartPreventDefault: true,
      threshold: 5,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      resistanceRatio: 0.85,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: true,
      initialSlide: getInitialSlide(),
      speed: 400,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true
      },
      breakpoints: {
        768: {
          spaceBetween: 0,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 0,
          slidesPerView: 4.1
        }
      },
      on: {
        init: () => {
          this.disableNativeImageDrag();
          this.updateActiveSlide();
        },
        slideChange: () => this.updateActiveSlide()
      }
    };

    if (autoplayEnabled) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }

    this.swiper = new Swiper(swiperEl, swiperOptions);
  }

  updateActiveSlide() {
    if (!this.swiper) return;

    const slides = this.querySelectorAll('.swiper-slide');
    slides.forEach((slide) => {
      const imageLink = slide.querySelector('.collection-zoom-carousel__image-link');
      if (imageLink) {
        imageLink.style.removeProperty('transform');
        imageLink.style.removeProperty('transform-origin');
      }
    });
  }

  positionFloatingElements() {
    const floats = this.querySelectorAll('.collection-zoom-carousel__float');
    floats.forEach((el) => {
      const left = el.dataset.left;
      const top = el.dataset.top;
      const right = el.dataset.right;
      const bottom = el.dataset.bottom;
      if (left != null) el.style.left = left;
      if (top != null) el.style.top = top;
      if (right != null) el.style.right = right;
      if (bottom != null) el.style.bottom = bottom;
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('collection-zoom-carousel', CollectionZoomCarousel);
